import React, { useState, memo, useCallback, useEffect, useRef } from 'react'
import { Popover } from '@material-ui/core'
import ReactHtmlParser from 'html-react-parser'

import { useTheme } from '@material-ui/core/styles'

import Typography from './typography'

import useStyles from './popoverStyle'

const BasicPopover = (props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [open, setOpen] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }
  const classes = useStyles()

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }

  const theme = useTheme()

  const renderContent = useCallback(() => {
    return (
      <ScrollH className={classes.container}>
        {props.content && (
          <Typography
            variant="body1"
            style={{
              color: theme.palette.primary.secondary,
              fontSize: theme.typography.fontSize - 2,
            }}
          >
            {ReactHtmlParser(props.content)}
          </Typography>
        )}
      </ScrollH>
    )
  }, [props?.content])

  return (
    <div>
      <div
        aria-describedby={'simple-popover'}
        variant="contained"
        onMouseEnter={handleClick}
        onClick={handleClick}
      >
        {props?.children}
      </div>
      <div>
        <Popover
          id={'simple-popover'}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <div onMouseLeave={handleClose}>{renderContent()}</div>
        </Popover>
      </div>
    </div>
  )
}

export default memo(BasicPopover)

export function MouseOverPopover(props) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <div>
      <div
        aria-describedby={id}
        variant="contained"
        onMouseEnter={handlePopoverOpen}
      >
        {props.children}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
      >
        <div onMouseLeave={handlePopoverClose}>{props.content()}</div>
      </Popover>
    </div>
  )
}

const ScrollH = ({ children, ...props }) => {
  const scrollRef = useRef()

  useEffect(() => {
    const el = scrollRef.current
    if (el) {
      const onWheel = (e) => {
        if (e.deltaY == 0) return
        e.preventDefault()
        el.scrollTo({
          left: el.scrollLeft + e.deltaY * 7,
          behavior: 'smooth',
        })
      }
      el.addEventListener('wheel', onWheel)
      return () => el.removeEventListener('wheel', onWheel)
    }
  }, [scrollRef])

  return (
    <div ref={scrollRef} {...props}>
      {children}
    </div>
  )
}
